export namespace RoleConstants {
  export const MOBILITY_MANAGER: string = 'Mobility Manager';
  export const MOBILITY_MANAGER_ADMIN: string = 'Mobility Manager Admin';
}
